import type { VNode } from 'vue';
import { onLongPress } from '@vueuse/core';
export const LongPressReport = {
  mounted(el: HTMLElement, binding: any, vNode: VNode) {
    if (typeof binding.value !== 'object') {
      throw 'callback must be a object';
    }
    const reporter = () => {
      _jt_.sendTracker({
        event_type: 'long_press',
        button_desc: 'long_press_btn',
        ...binding.value,
      });
    };
    onLongPress(el, reporter);
  },
};

export const LongPress = {
  mounted(el: HTMLElement, binding: any, vNode: VNode) {
    if (typeof binding.value !== 'function') {
      throw 'callback must be a function';
    }
    onLongPress(el, binding.value);
  },
};
